import type { SvgIconProps } from 'ui/icons/SvgIcon';
import { SecondaryDetailWrapper } from './styled';

type SecondaryDetailProps = {
  icon: React.ComponentType<React.PropsWithChildren<SvgIconProps>>;
  label: string;
};

export const SecondaryDetail = ({ icon: Icon, label }: SecondaryDetailProps) => (
  <SecondaryDetailWrapper>
    <Icon width={16} height={16} isColorInherited={true} />
    {label}
  </SecondaryDetailWrapper>
);
